<div class="input-dialog__container">
    <div class="input-dialog__header">
        <h3>{{title}}</h3>
    </div>
    <div class="input-dialog__content">
        <span [innerHTML]="text"></span>
        <input #input type="text" ax-input [placeholder]="inputPlaceholder" [(ngModel)]="inputValue" (keypress)="checkInput($event)">
    </div>
    <div class="input-dialog__footer">
        <button [ax-button]="buttonType" (click)="confirm()">
            <span class="ax-button__label">{{confirmButtonText}}</span>
        </button>
        <button ax-button (click)="cancel()">{{cancelButtonText}}</button>
    </div>
</div>